/** Private producer updates. The server sends these only to the authenticated host. */
export const PRESENTATION_RESEARCH_UPDATE = 'townhall:research_update';

export interface PresentationResearchUpdate {
  roomId: string;
  requestId: string;
  question: string;
  status: 'working' | 'ready' | 'unavailable' | 'expired';
  /** "search" is answered on air; "research"/"prepare" waits for "use that research". Absent from older servers. */
  delivery?: 'spoken' | 'private';
  expiresAt: number;
  subjects: Array<{
    subject: string;
    status: 'ready' | 'unavailable';
    sourceCount: number;
    sources?: Array<{ title: string; url: string; date?: string; excerpt?: string }>;
  }>;
}

export interface PresentationDeliveryPolicy {
  episodeId: string;
  revision: number;
  tone: 'default' | 'positive' | 'neutral' | 'serious';
  brevity: 'default' | 'brief';
  bannedPhrases: string[];
  notes: string[];
  updatedAt: number;
}

export interface PresentationDeliveryPatch {
  reset?: boolean;
  tone?: PresentationDeliveryPolicy['tone'];
  brevity?: PresentationDeliveryPolicy['brevity'];
  ban?: string;
  unban?: string;
  note?: string;
  removeNote?: string;
}
